module.exports = __webpack_public_path__ + "img/1b.d06aee7e.png";